import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteTransaction } from "../../../../redux/slices/transactionSlice";
import { Button, Modal } from "reactstrap";
import { responseToaster } from "../../../../helperFunctions";
import CustomeButton from "../../Forms/CustomeButton/CustomeButton";

const TransactionDeleteModal = (props) => {
  const { isOpen, onHide, onGet } = props;

  const dispatch = useDispatch();
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const onDelete = async () => {
    try {
      setIsButtonLoading(true);
      let payload = {
        txnId: isOpen?.txnId,
        payment_amount: isOpen?.paymentAmt,
      };
      let response = await dispatch(deleteTransaction(payload)).unwrap();
      responseToaster(response);
      if (!!response) {
        onClose();
        onGet();
      }
      setIsButtonLoading(false);
    } catch (err) {
      setIsButtonLoading(false);
    }
  };

  const onClose = () => {
    onHide();
  };

  return (
    <Modal isOpen={!!isOpen} toggle={onClose} centered={true}>
      <div className="modal-header">
        <h3 className="modal-title mt-0">Transaction Delete</h3>
        <i onClick={() => onClose()} className="fa-solid fa-xmark"></i>
      </div>
      <div className="modal-body">
        <div>
          <p>Are you sure you want to delete transaction?</p>
        </div>
      </div>
      <div className="modal-footer">
        <div className="d-flex justify-content-end button-space">
          <Button className="graybutton" onClick={() => onClose()}>
            Cancel
          </Button>
          <CustomeButton
            className="submitbutton"
            onClick={onDelete}
            isButtonLoading={isButtonLoading}
          >
            Submit
          </CustomeButton>
        </div>
      </div>
    </Modal>
  );
};

export default TransactionDeleteModal;
